import React from "react";
import { Form } from 'react-bootstrap';
import Utilities from "../classes/Utilities";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface ICalendarProps {
    id: string,
    value?: Date | null,
    placeholder?: string,
    validated: boolean,
    validationError: string,
    minDate?: Date,
    maxDate?: Date,
    onChange?: (date: Date | null) => void,
    disabled?: boolean | null;
}

interface IState {
    value: Date | null,
    disabled: boolean | null;
}

export class Calendar extends React.Component<ICalendarProps, IState> {
    constructor(props: ICalendarProps) {
        super(props);
        this.state = {
            value: this.props.value ? this.props.value : new Date(),
            disabled: this.props.disabled ? this.props.disabled : false
        };
    }

    private onChange = (date) => {
        this.setState({ ...this.state, value: date });
        this.setState({ value: date }, () => {
            if (this.props.onChange) {
                this.props.onChange(date);
            }
        });
    }

    public render() {
        const calendar = <DatePicker
                            key={this.props.id + "datePicker"}   
                            className={"form-control " + (this.props.validated ? (this.props.validationError ? "is-invalid" : "is-valid") : "")}
                            placeholder={this.props.placeholder}
                            maxLength={10}
                            minDate={this.props.minDate}
                            maxDate={this.props.maxDate}
                            onChange={this.onChange}
                            selected={this.state.value}
                            disabled={this.state.disabled} />;

        return (this.props.validated && this.props.validationError ?
            [
                calendar,
                <Form.Control.Feedback type="invalid" key={this.props.id + "_datePickerFeedback"}>
                    {this.props.validationError}
                </Form.Control.Feedback>
            ]
            :
            [ calendar ]
        );
    }
}

export default Calendar;